<!--材料预约列表-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          slot="organizationCode"
          v-decorator="['organizationCode', { initialValue: organizationCodeOrigin }]"
          selectType="selectAssemble"
          :selectData="inventOrg"
          :disabled="isDisableOrganization"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :assembleLabel="true"
          @change="inventOrgValueOnChange"
        />
        <global-select
          slot="workshopCode"
          :value.sync="queryParams.workshopCode"
          :selectData="workshopList"
          selectType="selectAssembleFilter"
          :selectItem="{ value: 'workshopCode', label: 'workshopDesc' }"
        />
        <global-select
          slot="teamCode"
          searchParam="teamCode"
          selectType="selectAssembleSearch"
          :value.sync="queryParams.teamCode"
          requestApi="/bom/team/list"
          :selectItem="{ value: 'teamCode', label: 'teamName' }"
        />
        <a-select
          slot="enable"
          v-model="queryParams.enable"
          placeholder="请选择"
        >
          <a-select-option :value="1">是</a-select-option>
          <a-select-option :value="0">否</a-select-option>
        </a-select>
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiTeamScheduleExport" ref="download" />
        <import-excel ref="importExcelRef" :downloadParams="downloadParams" :uploadParams="upload" @refresh="() => handleOk(false)" />
        <create-modal ref="createModalRef" @refresh="handleOk" />
        <a-button v-hasPermi="['bom:bomTeamScheduleCc:save']" type="primary" :loading="loading" @click="onCreate">新增</a-button>
        <a-button v-hasPermi="['bom:bomTeamScheduleCc:remove']" :loading="loading" @click="onDelete">失效</a-button>
        <a-button type="primary" :loading="loading" v-hasPermi="['bom:bomTeamScheduleCc:import']" @click="handleImport">导入</a-button>
        <a-button type="primary" :loading="loading" v-hasPermi="['bom:bomTeamScheduleCc:export']" @click="handleExport">导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          @selectedRowChange="selectedRowChange"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
        >
          <!-- 工作中心 -->
          <template slot="centerName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <global-select
              v-else
              class="pub-select"
              searchParam="centerCode"
              selectType="selectAssembleSearch"
              :value.sync="record.centerCode"
              requestApi="/bom/workCenter/list"
              :selectItem="{ value: 'centerCode', label: 'centerName' }"
              :setParams="{ 'workshopCode': record.workshopCode }"
            />
          </template>
          <!-- 模式名称 -->
          <template slot="modeName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <global-select
              v-else
              class="pub-select"
              searchParam="modeCode"
              selectType="selectAssembleSearch"
              :value.sync="record.modeCode"
              requestApi="/bom/attendanceMode/list"
              :selectItem="{ value: 'modeCode', label: 'modeName' }"
              :setParams="{ 'organizationCode': record.organizationCode }"
            />
          </template>
          <!-- 开始时间 -->
          <template slot="startTime" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
            <a-date-picker
              v-else
              style="width: 100%"
              v-model="record.startTime"
              show-time
              format="YYYY-MM-DD HH:mm:ss"
              value-format="YYYY-MM-DD HH:mm:ss"
            />
          </template>
          <!-- 结束时间 -->
          <template slot="endTime" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
            <a-date-picker
              v-else
              style="width: 100%"
              v-model="record.endTime"
              show-time
              format="YYYY-MM-DD HH:mm:ss"
              value-format="YYYY-MM-DD HH:mm:ss"
            />
          </template>
          <!-- 是否生效 -->
          <template slot="enable" slot-scope="{ text }">
            <span>{{ text ? '是' : '否' }}</span>
          </template>
          <!-- 备注 -->
          <template slot="remark" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input v-else v-model="record.remark" placeholder="请输入" :maxLength="100" />
          </template>
          <span slot="operation" slot-scope="text">
            <a
              v-if="(!isEdit || currentId !== text.record.id)"
              v-hasPermi="['bom:bomTeamScheduleCc:save']"
              @click="handleEdit(text.record)"
            >编辑</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
            <a class="ml10" @click="handleLog(text.record.id)"
            >日志</a>
          </span>
        </ls-api-table>
        <operation-log-model ref="operationLogModelRef" :logLoading="logLoading" :logList="logList" @closeLog="closeLogFun" />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import cloneDeep from 'lodash.clonedeep'
import cacheSearch from '@/mixins/cacheSearch'
import cacheRequest from '@/mixins/cacheRequest'

import {
  apiTeamScheduleList,
  apiTeamScheduleUpdate,
  apiTeamScheduleDel,
  apiTeamScheduleExport,
  apiGetLog
 } from '@/api/mes/productionPrepare/teamSchedule'
import { apiBomWorkshopFindList } from '@/api/mes/productionPrepare/attributeMaintenance'
import createModal from './components/create-modal.vue'
import ImportExcel from "@/components/ImportExcel/importExcel"
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import OperationLogModel from '@/components/operation-log/operation-log-model.vue'

import { mapState } from 'vuex'
import moment from 'moment';

export default {
  name: 'TeamSchedule',
  components: { DownloadModal, createModal, ImportExcel, OperationLogModel },
  mixins: [cacheSearch, cacheRequest],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    }),
    isDisableOrganization() {
      return this.organizationCodeOrigin !== 'A001'
    }
  },
  data() {
    return {
      apiTeamScheduleExport,
      loading: false, // 请求loading
      isEdit: false,
      currentId: '',
      selectedRowKeys: [],
      selectedRows: [],
      logLoading: false, // 日志loading
      logList: [], // 日志列表
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiTeamScheduleList, false),
        pageCurrent: true
      },
      // 用户导入参数
      upload: {
        url: process.env.VUE_APP_API_BASE_URL + '/bom/team/schedule/import' // 上传的地址
      },
      // 导入模板下载参数
      downloadParams: {
        method: 'post',
        url: 'bom/team/schedule/template',
        name: `班组排班导入模板_${moment().format('YYYY-MM-DD')}.xlsx`
      },
      workshopList: [], // 车间列表
      // 查询参数
      queryParams: {
        organizationCode: undefined,
        workshopCode: undefined,
        teamCode: undefined,
        enable: undefined
      },
      formList: [
        { label: '组织', decorator: ['organizationCode'], type: 'organizationCode' },
        { label: '车间', decorator: ['workshopCode'], type: 'workshopCode' },
        { label: '班组编码', decorator: ['teamCode'], type: 'teamCode' },
        { label: '是否生效', decorator: ['enable'], type: 'enable' }],
      // 表格字段
      columns: [
        { title: '组织', dataIndex: 'organizationName', align: 'center', width: 200 },
        { title: '车间', dataIndex: 'workshopDesc', align: 'center', width: 140 },
        { title: '班组', dataIndex: 'teamName', align: 'center', width: 140 },
        { title: '工作中心', dataIndex: 'centerName', scopedSlots: { customRender: 'centerName' }, align: 'center', width: 140 },
        { title: '开始日期', dataIndex: 'startTime', scopedSlots: { customRender: 'startTime' }, align: 'center', width: 240 },
        { title: '结束日期', dataIndex: 'endTime', scopedSlots: { customRender: 'endTime' }, align: 'center', width: 240 },
        { title: '出勤模式', dataIndex: 'modeName', scopedSlots: { customRender: 'modeName' }, align: 'center', width: 140 },
        { title: '是否生效', dataIndex: 'enable', scopedSlots: { customRender: 'enable' }, align: 'center', width: 140 },
        { title: '备注', dataIndex: 'remark', scopedSlots: { customRender: 'remark' }, align: 'center', width: 140 },
        { title: '创建人', dataIndex: 'createName', align: 'center', width: 100 },
        { title: '创建时间', dataIndex: 'createTime', align: 'center', width: 140 },
        { title: '修改人', dataIndex: 'updateName', align: 'center', width: 100 },
        { title: '修改时间', dataIndex: 'updateTime', align: 'center', width: 140 },
        {
          title: '操作',
          width: 95,
          align: 'center',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  created() {
    apiBomWorkshopFindList({
      workshopStatus: "Y",
      organizationCode: this.organizationCodeOrigin
    }).then(res => {
      if (res && res.length > 0) {
          this.workshopList = res
        } else {
          this.workshopList = []
        }
    });
    this.queryParams.organizationCode = this.organizationCodeOrigin;
  },
  mounted() {
    this.onSearch()
  },
  methods: {
    moment,
    // 加工组织
    inventOrgValueOnChange (val, status) {
      this.queryParams.workshopCode = '';
      apiBomWorkshopFindList({ organizationCode: val, workshopStatus: "Y" }).then(res => {
        if (res && res.length > 0) {
          this.workshopList = res
        } else {
          this.workshopList = []
        }
      })
    },
    // 行选中
    selectedRowChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    // 编辑
    handleEdit(record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return
      }
      this.isEdit = true
      this.currentId = record.id
    },
    // 保存
    handleSave(record) {
      if (!record?.centerCode) {
        this.$message.warning('请输入工作中心')
        return
      }
      if (!record?.startTime) {
        this.$message.warning('请输入开始日期')
        return
      }
      if (!record?.endTime) {
        this.$message.warning('请输入结束日期')
        return
      }
      this.loading = true

      apiTeamScheduleUpdate(record)
        .then((res) => {
          if (res?.code === 200) {
            this.$message.success('编辑成功')
            this.handleOk(true)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 取消
    handleCancel() {
      this.handleOk(true)
    },
    // 新增/修改框事件, changePage为true，则不返回到第一页
    handleOk(changePage = false) {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() }, changePage)
    },
    // 表单搜索
    onSearch(value = {}, changePage = false) {
      this.isEdit = false
      this.currentId = ''
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      this.setSearchCache(params) // 设置缓存
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData(changePage)
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        organizationCode: this.organizationCodeOrigin,
        workshopCode: undefined,
        teamCode: undefined,
        enable: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    },
    // 新增
    onCreate() {
      this.$refs.createModalRef.show()
    },
    // 删除
    onDelete() {
      if(this.selectedRows?.length < 1) {
        return this.$message.warning("请勾选单据进行操作")
      }
      const self = this
      self.$confirm({
        title: '提示',
        content: '请确认是否失效勾选单据？',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          self.loading = true;
          const ids = self.selectedRows.map(item => item.id)
          apiTeamScheduleDel(ids).then(res => {
            if (res?.code === 200) {
              self.$message.success(res?.msg || '操作成功')
              self.handleOk()
            }
          }).finally(() => {
            self.loading = false;
          })
        }
      })
    },
    // 操作日志弹窗
    handleLog(ids) {
      this.logList = []
      this.logLoading = true
      this.$refs.operationLogModelRef.show()
      apiGetLog({ id: ids, type: 4 }).then(res => {
        if (res.code === 200) {
          if (res?.data?.length > 0) { this.logList = res.data }
        }
      }).finally(() => {
        this.logLoading = false
      })
    },
    // 关闭日志弹窗
    closeLogFun() {
      this.logLoading = false;
      this.logList = [];
    },
    // 导入弹窗
    handleImport() {
      this.$refs.importExcelRef.show()
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less">
.pub-select {
  /deep/ .ant-select {
    width: 100%;
  }
}
</style>
